import * as React from "react";
import i18n from "Translations/i18n";
import styles from "./Autocomplete.scss";
import { AutocompleteEntry } from "./AutocompleteEntry";
import { KeyCode } from "./KeyCode";

interface IProps {
    entries?: AutocompleteEntry[];
    show: boolean;
    children?: React.ReactNode[] | React.ReactNode;
    noItemsFoundMessage: string;
    isSearching?: boolean;
    onFocus(): void;
    onBlur(): void;
    onEntrySelected(entry: AutocompleteEntry): void;
    onHighlightChanged?(hasHighlight: boolean): void;
}

interface IState {
    entries?: AutocompleteEntry[];
    show: boolean;
    highlightEntry: number;
}

export class Autocomplete extends React.Component<IProps, IState> {

    public static CALLBACK_DELAY = 300;

    constructor(props: IProps) {
        super(props);

        this.state = {
            entries: props.entries,
            show: props.show,
            highlightEntry: -1
        };

        this.onAutocompleteEntryClicked = this.onAutocompleteEntryClicked.bind(this);
        this.onFocusHandler = this.onFocusHandler.bind(this);
        this.onBlurHandler = this.onBlurHandler.bind(this);
        this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
    }

    public onAutocompleteEntryClicked(item: AutocompleteEntry) {
        this.props.onEntrySelected(item);
    }

    public componentDidUpdate(prevProps: IProps, prevState: IState) {
        if (this.props.onHighlightChanged && this.state.highlightEntry !== prevState.highlightEntry) {
            this.props.onHighlightChanged(this.state.highlightEntry >= 0);
        }
    }

    public onMouseEnterHandler(index: number) {
        this.setState({ highlightEntry: index });
    }

    public onFocusHandler() {
        window.setTimeout(this.props.onFocus, Autocomplete.CALLBACK_DELAY);
    }

    public onBlurHandler() {
        window.setTimeout(() => {
            this.setState({ highlightEntry: -1 });
            this.props.onBlur();
        }, Autocomplete.CALLBACK_DELAY);
    }

    public onKeyDownHandler(e: React.KeyboardEvent<HTMLInputElement>) {
        if (this.state.entries && this.state.entries.length) {
            let highlightEntry = this.state.highlightEntry;

            if (e.keyCode === KeyCode.ARROW_DOWN_KEY_CODE && ++highlightEntry === this.state.entries.length) {
                highlightEntry = 0;
            }
            else if (e.keyCode === KeyCode.ARROW_UP_KEY_CODE && --highlightEntry < 0) {
                highlightEntry = this.state.entries.length - 1;
            }
            else if (e.keyCode === KeyCode.RETURN_KEY_CODE && highlightEntry > -1) {
                this.onAutocompleteEntryClicked(this.state.entries[highlightEntry]);
                highlightEntry = -1;
            }

            this.setState({ highlightEntry });
        }
    }

    public static getDerivedStateFromProps(nextProps: IProps, prevState: IState): Partial<IState> {
        const partialState: Partial<IState> = {};

        if (nextProps.show !== prevState.show) {
            partialState.show = nextProps.show;
        }

        if (nextProps.entries !== prevState.entries) {
            partialState.entries = nextProps.entries;
        }

        return partialState;
    }

    public render() {
        return (
            <div className={styles.autocomplete} onFocus={this.onFocusHandler} onBlur={this.onBlurHandler} onKeyDown={this.onKeyDownHandler} >
                {this.props.children}
                {
                    this.state.show && this.state.entries &&
                    <div className={styles.entries}>
                        {
                            this.props.isSearching ? i18n.t("common.searching") :
                                !this.state.entries.length
                                    ? <div className={styles.entry}>{this.props.noItemsFoundMessage}</div>
                                    : this.state.entries.map((entry, index) => {
                                        return (
                                            <div id={`divAutocompleteEntry_${index}`} key={entry.key} className={`${styles.entry} ${styles.selectable} ${this.state.highlightEntry === index ? styles.highlight : null}`} onClick={(() => this.onAutocompleteEntryClicked(entry))} onMouseEnter={(() => this.onMouseEnterHandler(index))}>
                                                {entry.text}
                                            </div>
                                        );
                                    })
                        }
                    </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Autocomplete/Autocomplete.tsx